import script from "./TypeChart.vue?vue&type=script&lang=js"
export * from "./TypeChart.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__